<template>
    <router-view />
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == 'vendas-feriados') {
            next({ name: 'vendas-feriados-list' });
        } else if (to.name == 'promotor-feriados') {
            next({ name: 'promotor-feriados-list' });
        } else if (to.name == 'des-feriado') {
            next({ name: 'des-feriados-list' });
        } else if (to.name == 'agro-feriados') {
            next({ name: 'agro-feriados-list' });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == 'vendas-feriados') {
            this.$router.push({ name: 'vendas-feriados-list' });
        } else if (this.$route.name == 'promotor-feriados') {
            this.$router.push({ name: 'promotor-feriados-list' });
        } else if (this.$route.name == 'des-feriado') {
            this.$router.push({ name: 'des-feriados-list' });
        } else if (this.$route.name == 'agro-feriados') {
            this.$router.push({ name: 'agro-feriados-list' });
        }
    },
};
</script>
